import React from 'react';
import { Company, Order, User } from '../../../models';
import { roles } from '../../../static';
import { useUser } from '../../../hooks';
import { mergeItemsAndUsersByClient } from '../../../lib';
import OrderSummary from './OrderSummary/OrderSummary';
import ClientDetail from './ClientDetail';
import OrderInfo from './OrderInfo';
import OrderButtons from './OrderButtons';

interface OrderDetailProps {
  order: Order;
  refreshData: () => Promise<void>;
  users: User[];
}

function OrderDetail({ order, users, refreshData }: OrderDetailProps) {
  const [user] = useUser();

  const _order = React.useMemo(() => {
    const orderWithClients = mergeItemsAndUsersByClient(order, users);
    if (user.userType !== roles.ally) {
      return orderWithClients;
    }
    return {
      ...order,
      products: orderWithClients.products.filter(
        (product) => product.company === (user.company as Company)?._id
      ),
    };
  }, [order]);

  return (
    <div className="w-full flex flex-wrap">
      <div className="w-full lg:w-2/3 flex flex-col pr-0 sm:pr-5 mb-5 ">
        <OrderSummary order={_order as Order} />
        <ClientDetail
          user={order?.user}
          paymentInfo={order?.paymentInfo}
          status={(_order as Order).status}
        />
      </div>
      <div className="w-full lg:w-1/3 flex flex-col">
        <OrderInfo order={order} />
        {user.userType === roles.admin ? (
          <OrderButtons order={order} refreshData={refreshData} />
        ) : null}
      </div>
    </div>
  );
}

export default OrderDetail;
